import { createGlobalStyle } from "styled-components";

/** Colors and base styles. Dark or light follows the device setting. */
export const GlobalStyle = createGlobalStyle`
    :root {
        --background: #f6f5fa;
        --surface: #ffffff;
        --text: #1d1b26;
        --muted: #6b6880;
        --border: #e2e0ea;
        --accent: #4a7bd0;
        --accent-text: #ffffff;
        --good: #2e8b57;
        --bad: #c0392b;
        --busy: #d4a017;
        color-scheme: light dark;
    }
    @media (prefers-color-scheme: dark) {
        :root {
            --background: #1d1b26;
            --surface: #27243a;
            --text: #eeecf5;
            --muted: #a29fb8;
            --border: #3a3654;
            --accent: #6f9be8;
            --accent-text: #11101a;
            --good: #5cc98a;
            --bad: #ef6b5b;
            --busy: #f2c94c;
        }
    }
    * { box-sizing: border-box; }
    body {
        margin: 0;
        background: var(--background);
        color: var(--text);
        font: 16px/1.5 system-ui, sans-serif;
    }
`;
